import React from "react";

function dashboard() {
  return <div>dashboard</div>;
}

export default dashboard;
